import { pipe } from 'fp-ts/function';
import { Cookie, Http, Tracking } from '@catawiki/runtime-toolkit';
import { API_COOKIES_ENDPOINT, COOKIE_PREFERENCES_SAVED_EVENT, } from '../constants';
export const dispatchCookiesPrefSavedEvent = () => {
    const closingEvent = new CustomEvent(COOKIE_PREFERENCES_SAVED_EVENT);
    window.dispatchEvent(closingEvent);
};
export const setHasPendingCookieConsentSync = (isPending = true) => {
    if (isPending) {
        Cookie.setHasPendingCookieConsentSync(true);
    }
    else {
        Cookie.deleteHasPendingCookieConsentSync();
    }
};
export const getCookieCta = (cta) => cta && ['accept_all', 'reject_all', 'manage'].includes(cta) ? cta : '';
const saveCookiePreferencesOnGA = (marketing, analytical) => {
    Tracking.pushGATrackingEvent('cookie_consent_interaction', {
        analytical_cookies: analytical,
        marketing_cookies: marketing,
    });
};
// Submits the user consent data to the backend, in order to persist it to BigQuery
export const saveConsentToBQ = ({ marketing, analytical, cta, }) => {
    const possibleValues = Object.entries({ marketing, analytical });
    const accepted = possibleValues
        .filter(([, enabled]) => enabled)
        .map(([cookieType]) => cookieType);
    const rejected = possibleValues
        .filter(([, enabled]) => !enabled)
        .map(([cookieType]) => cookieType);
    const promise = pipe(Http.putJson(API_COOKIES_ENDPOINT, {
        accepted_preferences: accepted.length ? accepted : '',
        rejected_preferences: rejected.length ? rejected : '',
        call_to_action: getCookieCta(cta),
    }), Http.send());
    promise.catch(setHasPendingCookieConsentSync);
    return promise;
};
export const saveCookiePreferences = ({ marketing, analytical, cta, }) => {
    saveCookiePreferencesOnGA(marketing, analytical);
    Cookie.setMarketingCookiesEnabled(marketing);
    Cookie.setAnalyticalCookiesEnabled(analytical);
    Cookie.setCookiePreferencesUsedCta(getCookieCta(cta));
    if (Cookie.getIsUserLoggedIn()) {
        return saveConsentToBQ({ marketing, analytical, cta });
    }
    else {
        setHasPendingCookieConsentSync();
    }
    return Promise.resolve();
};
//# sourceMappingURL=cookie.js.map